/*
    productRegistration: {
        products: [
            {
                id: '0w20011269', // product SKU
                name: 'Cooking Chef Gourmet KCC9048S', // product name (English)
                category: 'food mixers', // product category (English)
            },
        ],
    },
 */
export const registration_event = (data) => ({
    event: data.event || null,
    eventCategory: data.eventCategory || null,
    eventLabel: data.eventLabel || null,
    ...(data.eventAction && {eventAction: data.eventAction}),
    ecommerce: {
        productRegistration: data.productRegistration || null,
    },
})
